<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Navbar from '@/components/menu/Navbar.vue';
import OuterFrameBar from '@/components/layout/OuterFrameBar.vue';
import SettingsDialog from '@/components/settings/SettingsDialog.vue';
import { Toaster } from '@/components/ui/toast';
import CommonAlertDialog from '@/components/dialogs/common/CommonAlertDialog.vue';
import FullLoader from '@/components/fullLoader/FullLoader.vue';
import Footer from '@/components/footer/Footer.vue';
import { useSessionStore } from '@/stores/SessionStore.ts';
import ScreenCapturePreview from '@/components/screenCapturePreview/ScreenCapturePreview.vue';
import { useWebSocketStore } from '@/stores/WebSocketStore.ts';
import { useSettingsStore } from '@/stores/SettingsStore.ts';
import ConnectionBar from '@/components/menu/ConnectionBar.vue';
import ErrorBoundary from '@/components/index/ErrorBoundary.vue';
import { ROUTES } from '@/router.ts';
import UserMessageDialog from '@/components/dialogs/UserMessageDialog.vue';
import TrialInputWarningDialog from '@/components/dialogs/warnings/TrialInputWarningDialog.vue';
import CommonInputDialog from '@/components/dialogs/common/CommonInputDialog.vue';

const route = useRoute();

const sessionStore = useSessionStore();
const settingsStore = useSettingsStore();
const webSocketStore = useWebSocketStore();

const NAVBAR_HIDDEN_ROUTES: string[] = [
    ROUTES.authLogin,
    ROUTES.authRegister,
    ROUTES.webViewTransfer,
    ROUTES.errorNotFound,
    ROUTES.errorNotAllowed,
];

const showNavBar = computed(() => {
    return !NAVBAR_HIDDEN_ROUTES.includes(route.name as string);
});
</script>

<template>
    <main
        class="flex h-screen flex-col overflow-hidden bg-white dark:bg-zinc-900"
        :class="{
            'rounded-xl': !sessionStore.isInsideWebView,
        }"
    >
        <OuterFrameBar v-if="!sessionStore.isInsideWebView" class="h-[32px]" />
        <FullLoader />

        <template v-if="showNavBar">
            <Navbar class="h-[37px] flex-shrink-0" />
            <ConnectionBar
                class="h-[34px] flex-shrink-0"
                v-if="
                    !settingsStore.isOnboarding &&
                    (sessionStore.isInsideWebView ||
                        (!sessionStore.isInsideWebView &&
                            webSocketStore.connectedClients.length > 1))
                "
            />
        </template>

        <!-- Dialogs -->
        <SettingsDialog />
        <ScreenCapturePreview />
        <UserMessageDialog />
        <TrialInputWarningDialog />

        <!-- Top dialogs -->
        <CommonInputDialog />
        <CommonAlertDialog />

        <ErrorBoundary>
            <RouterView :key="$route.fullPath" />
        </ErrorBoundary>

        <Footer class="h-[38px] flex-shrink-0" />

        <Toaster />
    </main>
</template>
